const toNumber = (value, fallback = 0) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : fallback;
  }
  const parsed = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const firstNonEmpty = (...values) => {
  for (const value of values) {
    const text = String(value || '').trim();
    if (text) {
      return text;
    }
  }
  return '';
};

export const DEFAULT_SERVICE_SCHEMA = {
  id: 'service-default',
  title: 'Service Details',
  name: 'Service Details',
  description: '',
  detailedDescription: '',
  image: '🕉️',
  icon: '🕉️',
  rating: 0,
  reviews: 0,
  reviewCount: 0,
  price: 0,
  originalPrice: 0,
  duration: 'N/A',
  location: '',
  category: 'General',
  features: [],
  tags: [],
  badge: '',
  servicePage: 'home'
};

export const normalizeService = (service = {}, defaults = {}) => {
  const base = {
    ...DEFAULT_SERVICE_SCHEMA,
    ...defaults,
    ...(service || {})
  };

  const title = firstNonEmpty(base.title, base.name, defaults.title, DEFAULT_SERVICE_SCHEMA.title);
  const name = firstNonEmpty(base.name, base.title, defaults.name, DEFAULT_SERVICE_SCHEMA.name);
  const description = firstNonEmpty(base.description, base.detailedDescription, defaults.description, '');
  const image = firstNonEmpty(base.image, base.icon, defaults.image, DEFAULT_SERVICE_SCHEMA.image);
  const duration = firstNonEmpty(base.duration, defaults.duration, DEFAULT_SERVICE_SCHEMA.duration);
  const category = firstNonEmpty(base.category, defaults.category, DEFAULT_SERVICE_SCHEMA.category);
  const id = firstNonEmpty(base.id, `${name}-${category}`.toLowerCase().replace(/\s+/g, '-'));

  const price = toNumber(base.price, 0);
  const originalPrice = toNumber(base.originalPrice, price);
  const rating = Number(base.rating || 0) || 0;
  const reviews = toNumber(base.reviews ?? base.reviewCount, 0);

  return {
    ...base,
    id,
    title,
    name,
    description,
    detailedDescription: firstNonEmpty(base.detailedDescription, description),
    image,
    icon: image,
    duration,
    category,
    price,
    originalPrice,
    rating,
    reviews,
    reviewCount: reviews,
    location: firstNonEmpty(base.location),
    features: Array.isArray(base.features) ? base.features : [],
    tags: Array.isArray(base.tags) ? base.tags : [],
    badge: firstNonEmpty(base.badge),
    servicePage: firstNonEmpty(base.servicePage, defaults.servicePage, DEFAULT_SERVICE_SCHEMA.servicePage)
  };
};

export const normalizeServiceList = (services = [], defaults = {}) => {
  if (!Array.isArray(services)) {
    return [];
  }
  return services.map((service) => normalizeService(service, defaults));
};
